import { Action } from 'redux';
import { isType } from 'typescript-fsa';

import * as Actions from '../actions/scorm';

/**
 * eラーニングSCORMのState型
 */
export interface IScormState {
	readonly startTime: string;
	readonly location: string;
}

/**
 * eラーニングSCORMのState初期値
 */
const initialState: IScormState = {
	location: '',
	startTime: '',
};

/**
 * eラーニングSCORM用reducer
 * @param state State
 * @param action アクション
 */
const scorm = (state = initialState, action: Action) => {
	if (isType(action, Actions.setScormParams)) {
		return {
			...state,
			location: action.payload.location,
			startTime: action.payload.startTime,
		};
	}

	if (isType(action, Actions.clearScormParams)) {
		return initialState;
	}

	return state;
};

export default scorm;



// WEBPACK FOOTER //
// ./src/reducers/scorm.ts